{
    "coordinates": [
        -39.39920845707707,
        -69.18997510878265
    ],
    "tooltip": "Candeleros",
    "title": "Candeleros Formation",
    "country": "Argentina",
    "period": "Cretaceous",
    "alt": "TODO"
}
